import React, { useState } from 'react';
import classes from "./UnsubModal.module.css";
import { unsubscribeAPI } from '../../api/api';
import { useAppDispatch, useAppSelector } from '../../Store/hooks';
import { logoutUser } from '../../Slices/userSlice';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { toggleUnsubModal } from '../../Slices/unsubModalSlice';

const UnsubModal = () => {
    const { user } = useAppSelector(state => state.userSlice);
    const [deactivateLoading, setDeactivateLoading] = useState(false);
    const dispatch = useAppDispatch();

    const { unsubModal } = useAppSelector(state => state.unsubModalSlice);

    const handleDeactivate = async () => {
        try {
            setDeactivateLoading(true);
            const response = await unsubscribeAPI(user?.msisdn);
            setDeactivateLoading(false);
            dispatch(toggleUnsubModal());
            dispatch(logoutUser(null));
            toast.success("Unsubscribed Successfully!");
            setTimeout(() => {
                window.location.href = "/";
            }, 500);
        } catch (error) {
            setDeactivateLoading(false);
            toast.error("Something Went Wrong! Try Again!");
        }
    }

    return (
        <div className={classes.modalOverlay}>
            <div className={classes.modal}>
                <h3>Confirm Unsubscription</h3>
                <p>Are you sure you want to unsubscribe from service?</p>
                <div className={classes.modalActions}>
                    <button
                        onClick={() => {
                            dispatch(toggleUnsubModal())
                        }}
                        disabled={deactivateLoading}
                    >Cancel</button>
                    <button onClick={handleDeactivate}
                        disabled={deactivateLoading}
                        className={classes.confirmButton}>
                        {deactivateLoading ? "Please Wait..." : "Unsubscribe"}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default UnsubModal